// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

import * as Sentry from '@sentry/nextjs';
import { ENVIRONMENT_NAME } from '@/services/Configuration.js';
import { ExtraErrorData } from '@sentry/integrations';

const SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
const SENTRY_ENVIRONMENT = ENVIRONMENT_NAME || process.env.ENVIRONMENT_NAME || 'development'

Sentry.init({
  dsn: SENTRY_DSN || 'https://636b9931b0164c9f99f8d182cb8badaa@o32694.ingest.sentry.io/6611343',
  // Adjust this value in production, or use tracesSampler for greater control
  tracesSampleRate: 1.0,
  environment: SENTRY_ENVIRONMENT,
  normalizeDepth: 11,
  integrations: [new ExtraErrorData({ depth: 10 })],
  // ...
  // Note: if you want to override the automatic release value, do not set a
  // `release` value here - use the environment variable `SENTRY_RELEASE`, so
  // that it will also get attached to your source maps
});
